import { render, staticRenderFns } from "./ProcessedDataResults.vue?vue&type=template&id=02966562"
import script from "./ProcessedDataResults.vue?vue&type=script&lang=js"
export * from "./ProcessedDataResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports